import { render, staticRenderFns } from "./user_gl.vue?vue&type=template&id=4128483e&scoped=true&"
import script from "./user_gl.vue?vue&type=script&lang=js&"
export * from "./user_gl.vue?vue&type=script&lang=js&"
import style0 from "./user_gl.vue?vue&type=style&index=0&id=4128483e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128483e",
  null
  
)

export default component.exports